import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaTicketAlt, FaUserCircle, FaSignOutAlt, FaSignInAlt, FaUserPlus, FaHome } from 'react-icons/fa';
import logo from '../assets/logo.svg';

export default function Navbar() {
    const navigate = useNavigate();
    const token = localStorage.getItem('token');

    const handleLogout = () => {
        localStorage.removeItem('token');
        navigate('/login');
    };

    return (
        <nav className="navbar navbar-expand-lg navbar-dark navbar-glass sticky-top py-3">
            <div className="container">
                <Link className="navbar-brand fw-bold d-flex align-items-center" to="/">
                    <img src={logo} alt="TicketFlow Logo" width="32" height="32" className="me-2" />
                    <span style={{ letterSpacing: '1px' }}>TicketFlow</span>
                </Link>

                <div className="collapse navbar-collapse">
                    <ul className="navbar-nav ms-auto align-items-center">
                        <li className="nav-item">
                            <Link className="nav-link d-flex align-items-center" to="/">
                                <FaHome className="me-1" /> Home
                            </Link>
                        </li>

                        {token ? (
                            <>
                                <li className="nav-item ms-3">
                                    <Link className="nav-link d-flex align-items-center" to="/my-tickets">
                                        <FaUserCircle className="me-1" /> My Tickets
                                    </Link>
                                </li>
                                <li className="nav-item ms-3">
                                    <button
                                        className="btn btn-outline-light btn-sm rounded-pill px-4 py-2 d-flex align-items-center"
                                        onClick={handleLogout}
                                    >
                                        <FaSignOutAlt className="me-2" /> Logout
                                    </button>
                                </li>
                            </>
                        ) : (
                            <>
                                <li className="nav-item ms-3">
                                    <Link className="nav-link d-flex align-items-center" to="/login">
                                        <FaSignInAlt className="me-1" /> Login
                                    </Link>
                                </li>
                                <li className="nav-item ms-2">
                                    <Link className="btn btn-info btn-sm rounded-pill px-4 py-2 fw-bold text-dark d-flex align-items-center shadow-sm" to="/register">
                                        <FaUserPlus className="me-2" /> Sign Up
                                    </Link>
                                </li>
                            </>
                        )}
                    </ul>
                </div>
            </div>
        </nav>
    );
}